import { restApiClient } from "@lobby/api-client";

import type { Output } from "@lobby/api-client/src/codegen-rest";

export type LobbySettings = Output<"GET /api/v1/settings">;

export async function fetchLobbySettings(): Promise<LobbySettings> {
  const data = await restApiClient.send({
    endpoint: "GET /api/v1/settings",
    query: {
      language: "en",
    },
  });

  return data;
}
